import classNames from "classnames";
import React, { FC, useEffect } from "react";
import { Button } from "../button";
import { CSS_CLASSES } from "./tab-css-classes";
import { UncontrolledTabProps } from "./tab.types";

export const UncontrolledTab: FC<UncontrolledTabProps> = ({
  className: classNameProp,
  color,
  label,
  labelAlign = "center",
  ripple,
  disabled = false,
  id,
  panelId,
  active,
  focus = false,
  onTabClick,
  buttonRef,
  badge,
  ...restProps
}) => {
  useEffect(() => {
    if (focus) {
      buttonRef.current.focus();
    }
  }, [buttonRef, focus]);

  const tabIndex = active ? 0 : -1;
  const className = classNames(
    CSS_CLASSES.TAB,
    {
      [CSS_CLASSES.TAB_DISABLED]: disabled,
      [CSS_CLASSES.TAB_ACTIVE]: active,
      [CSS_CLASSES.TAB_INACTIVE]: !active,
    },
    classNameProp
  );
  return (
    <Button
      // @todo: post Button refactor for bundle size, the ripple effect on tab buttons seems to be broken.
      // Needs to be investigated and fixed. Until then ripple is disabled.
      // UPDATE: this is most likely fixed by the `position: relative` fix done to button styles.
      // test and remote todo if indeed fixed
      ripple={false}
      variant="ghost"
      color={color}
      label={label}
      title={label}
      width="full"
      labelAlign={labelAlign}
      size="medium"
      shape="square"
      ref={buttonRef}
      role="tab"
      id={id}
      disabled={disabled}
      aria-selected={active}
      aria-disabled={disabled}
      aria-controls={panelId}
      tabIndex={tabIndex}
      className={className}
      onClick={onTabClick}
      endIcon={badge}
      active={active}
      {...restProps}
    ></Button>
  );
};

UncontrolledTab.displayName = "Tab";
